<script setup lang="ts">
  import SearchFilterProvider from './SearchFilterProvider.vue'
  import {
    defineStakeholderSearchContext,
    provideStakeholderSearch
  } from '../../composables/useStakeholderSearch'

  const { quickSearchState, advancedSearchState, pageState } =
    defineStakeholderSearchContext()

  provideStakeholderSearch({
    quickSearchState,
    advancedSearchState,
    pageState
  })
</script>

<template>
  <SearchFilterProvider :search-filters="advancedSearchState.searchFilters">
    <slot />
  </SearchFilterProvider>
</template>
